import { Component, OnInit } from '@angular/core'
import { RecursoService } from 'src/app/services/recurso.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-recursos-pendentes',
  templateUrl: './recursos-pendentes.component.html',
  styleUrls: ['./recursos-pendentes.component.css']
})
export class RecursosPendentesComponent implements OnInit {
  recursos: any[] = []
  loading = false

  constructor(
    private recursoService: RecursoService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.carregarRecursos()
  }

  carregarRecursos(): void {
    this.loading = true
    this.recursoService.listarRecursosPendentes().subscribe({
      next: (data) => {
        this.recursos = data
        this.loading = false
      },
      error: () => {
        this.loading = false
      }
    })
  }

  visualizar(id: number): void {
    this.router.navigate(['/recurso/analise', id])
  }

  visualizarNotas(id: number): void {
    this.router.navigate(['/comissao/recurso', id, 'notas'])
  }
}
